var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",on:{"click":_vm.doClick}},[_c('a',{class:_vm.linkClass,attrs:{"href":"javascript:;","data-toggle":"tab"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }